import { RouletteStorageService } from "src/application/ports";
import { useStore } from "./store";

export function useRouletteStorage(): RouletteStorageService {
  return useStore();
}
